import React from 'react';
import { Building2, HeartPulse, ShoppingCart, Factory, Cpu, Radio } from 'lucide-react';
import { industries } from '../mockData';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { useNavigate } from 'react-router-dom';

const iconMap = {
  'building-2': Building2,
  'heart-pulse': HeartPulse,
  'shopping-cart': ShoppingCart,
  factory: Factory,
  cpu: Cpu,
  radio: Radio
};

const Industries = () => {
  const navigate = useNavigate();

  return (
    <section id="industries" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#1A3E6E] font-semibold text-sm uppercase tracking-wide">
            Industries We Serve
          </span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-bold text-gray-900">
            Specialized Industry Solutions
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Our expertise spans across multiple industries, delivering tailored technology solutions
            that address unique sector challenges.
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry) => {
            const IconComponent = iconMap[industry.icon];
            return (
              <Card
                key={industry.id}
                onClick={() => navigate('/contact')}
                className="hover:shadow-xl transition-all duration-300 border-2 hover:border-[#1A3E6E] group cursor-pointer"
              >
                <CardHeader>
                  <div className="flex items-center space-x-4">
                    <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center group-hover:bg-[#1A3E6E] transition-colors duration-300">
                      <IconComponent className="text-[#1A3E6E] group-hover:text-white transition-colors duration-300" size={28} />
                    </div>
                    <CardTitle className="text-xl group-hover:text-[#1A3E6E] transition-colors">
                      {industry.name}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 mb-4">
                    {industry.description}
                  </CardDescription>
                  <p className="text-[#1A3E6E] text-sm font-semibold group-hover:underline">
                    Contact us to learn more →
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
